import { api } from './networkService';

class CityPriceService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/city/branch`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch city price error:', error);
            throw error;
        }
    }

    static async fetchByUser() {
        try {
            const response = await api.get(`api/user/city/branch/user`);
            return response.data;
        } catch (error) {
            console.error('Fetch city price error:', error);
            throw error;
        }
    }

    static async add(cityPrice) {
        try {
            const response = await api.post(`api/user/city/branch`, cityPrice);
            return response;
        } catch (error) {
            console.error('Add city price error:', error);
            throw error;
        }
    }

    static async update(cityPrice) {
        try {
            const { id, ...info } = cityPrice;
            const response = await api.put(`api/user/city/branch/${id}`, info);
            return response;
        } catch (error) {
            console.error('Update city price error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/city/branch/${id}`);
            return response;
        } catch (error) {
            console.error('Delete city price error:', error);
            throw error;
        }
    }
}

export default CityPriceService;
